export const CAMPAIGN_ROUTE="/campaigns";